import React, { useState } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { Card, ListItemText, Typography } from '@material-ui/core';
import { NetworkStatus } from '@apollo/client';

import { ErrorComponent, LoadingSpinner } from '../../../../components';
import { GQLOperationBuilder } from '../../../../operations/GQLOperationBuilder';
import { ProducerNavigation } from '../../navigation/ProducerNavigation';
import FontTextSamples from '../../../../components/FontTextSamples/FontTextSamples';

const FontDetails = () => {
  const [errorComponentState, setErrorComponentState] = useState(false);

  const fontId = ProducerNavigation.fontDetails.paramsFromPath(useRouteMatch()).fontId;

  const { data, loading, error, networkStatus, refetch } = GQLOperationBuilder.font.getFont({
    fontId: fontId
  });

  if (loading || networkStatus === NetworkStatus.refetch) return <LoadingSpinner />;

  if (error && !errorComponentState)
    return (
      <ErrorComponent
        close={setErrorComponentState}
        details={error?.stack}
        message={error.message}
        callback={refetch}
      />
    );

  const selectedFont = GQLOperationBuilder.font.fontAssetFromResponse(data);

  return (
    selectedFont && (
      <div>
        <Card style={{ padding: '8px', marginBottom: '8px' }}>
          <div style={{ display: 'flex' }}>
            <Typography style={{ marginRight: '2px' }} variant={'h6'}>
              Font Details
            </Typography>
          </div>
          <ListItemText primary="Font name" secondary={selectedFont.font.name} />
        </Card>
        <FontTextSamples fontAsset={selectedFont} />
      </div>
    )
  );
};

export default FontDetails;
